import { useFeatureFlagGate, type FeatureGateStatus } from '@/hooks/use-feature-flag-gate';
import { FeatureFlag } from '@fluenceur/types';
import { useQueryStates } from 'nuqs';
import { useEffect } from 'react';
import { contactDrawerParsers } from './contact-drawer-url-state';
import type { ContactView } from './contact-views';

type BlockedContactViewReset = {
  contactView: 'profile';
  contactCollab: null;
  contactDeliverable: null;
};

export const blockedContactViewReset = (
  contactView: ContactView,
  collabsGate: FeatureGateStatus
): BlockedContactViewReset | null => {
  if (contactView !== 'collabs' || collabsGate !== 'denied') return null;

  return {
    contactView: 'profile',
    contactCollab: null,
    contactDeliverable: null,
  };
};

/** Prevents feature-gated drawer views from being restored through a stale URL. */
export const useContactFeatureGuard = () => {
  const [{ contactView }, setParams] = useQueryStates(contactDrawerParsers);
  const collabsGate = useFeatureFlagGate(FeatureFlag.COLLABS);

  useEffect(() => {
    const reset = blockedContactViewReset(contactView, collabsGate);
    if (reset) void setParams(reset);
  }, [collabsGate, contactView, setParams]);

  return {
    collabsEnabled: collabsGate === 'granted',
    canRenderContactView: contactView !== 'collabs' || collabsGate === 'granted',
  };
};
